import React from 'react'
import { Space, Tag } from '@bedrock/components'
import classNames from 'classnames/bind'
import styles from './index.less'
import { TagColor } from "@bedrock/components/lib/Tag/Tag";

const cx = classNames.bind(styles)

export default function OAStatusShow({ oaStatus, type = 'text' }: { oaStatus: string, type?: 'text' | 'tag' | 'dot' }) {
    let statusConfig: {
        text: string,
        tagColor: TagColor,
        dotColor: string,
    } = {
        text: '未知',
        tagColor: 'light-grey',
        dotColor: '#f8f9fa',
    }
    switch (oaStatus) {
        case 'SUBMITTING':
            statusConfig = {
                text: '提交中',
                tagColor: 'light-orange',
                dotColor: '#E08216',
            }
            break
        case 'NOT_SUBMITTED':
            statusConfig = {
                text: '未提交',
                tagColor: 'primary',
                dotColor: '#5154E0',
            }
            break
        case 'SUBMITTED':
            statusConfig = {
                text: '已提交',
                tagColor: 'light-blue',
                dotColor: '#1C80EB',
            }
            break
        case 'REJECTED':
            statusConfig = {
                text: '已驳回',
                tagColor: 'light-red',
                dotColor: '#E55140',
            }
            break
        case 'ARCHIVING':
            statusConfig = {
                text: '已归档',
                tagColor: 'light-green',
                dotColor: '#21A364',
            }
            break
        default:
            break
    }

    if (!oaStatus) return <span>--</span>
    if (type === 'tag') {
        return <Tag size="xSmall" color={statusConfig.tagColor} text={statusConfig.text} />
    }
    if (type === 'dot') {
        return <Space size={[8, 0]}>
            <span className={cx('dot')} style={{ backgroundColor: statusConfig.dotColor }} />
            {statusConfig.text}
        </Space>
    }
    return <span>statusConfig.text</span>
}

